const $ = require('jquery');
const _ = require('lodash');
const rive = require("@rive-app/canvas");

module.exports = class NewProductBlock {
  constructor($el) {
    this.$el = $el;
    this.steps = [];
    this.queue = []; // a method to be executed
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    if (window.innerWidth > 1024) {
      setInterval(() => {
        if (this.queue.length) {
          this.queue.shift()();
        }
      }, 100);

      setInterval(() => {
        const $content = this.$el.find("> div");
        const contentHeight = $content[0].getBoundingClientRect().height;
        const stepHeight = (
          this.$el[0].getBoundingClientRect().height - contentHeight
        ) / 5;
        const step = Math.ceil(
          (Math.abs(
              $el[0].getBoundingClientRect().top -
              $content[0].getBoundingClientRect().top)
          ) / stepHeight
        );
        this.goToStep(step);
      }, 200);

      $el.find('[data-component="rive-animation"]').each((i, riveAnimation) => {
        const $riveAnimation = $(riveAnimation);
        const riveInstance = new rive.Rive({
          src: $riveAnimation.data('src'),
          layout: new rive.Layout({
            fit: rive.Fit.FitHeight,
            alignment: rive.Alignment.Center
          }),
          canvas: $riveAnimation[0],
          autoplay: true,
          stateMachines: "Animation",
          onLoad: () => {
            const inputs = riveInstance.stateMachineInputs("Animation");
            this.steps.push(inputs[0]);
          }
        });
      });

      const refreshPosition = () => {
        const $content = this.$el.find("> div");
        const contentHeight = $content[0].getBoundingClientRect().height;
        const expectedContentStartY = (window.innerHeight - contentHeight) / 2;
        $content.css("position", `sticky`);
        $content.css("top", `${expectedContentStartY}px`);
        window.requestAnimationFrame(refreshPosition);
      };

      refreshPosition();

      $el.find('[data-component="new-product-block-step-trigger"]')
        .on('click', e => this.clickStep($(e.target)));
    }
  }

  goToStep(step) {
    if (!this.steps || !this.steps.length) {
      console.log('steps undefined')
      return;
    }

    const delta = this.steps[0].value - step;
    const direction = delta > 0 ? this.previous : this.next;
    const distance = Math.abs(delta);
    _.range(distance).forEach(() => {
      this.queue.push(direction);
    });
  }

  next() {
    this.steps.forEach(step => step.value = _.clamp(step.value + 1, 0, 5));

    const step = this.steps[0].value;
    const entering = this.$el[0]
      .querySelector(`.animate__animated:nth-child(${step})`);
    const leaving = this.$el[0]
      .querySelector(`.animate__animated:nth-child(${step - 1})`);

    if (leaving) {
      leaving.classList.add('animate__fadeOutUp');
      leaving.classList.remove('animate__fadeOutDown');
      leaving.classList.remove('animate__fadeInUp');
      leaving.classList.remove('animate__fadeInDown');
    }

    if (entering) {
      entering.classList.add('animate__fadeInUp');
      entering.classList.remove('animate__fadeInDown');
      entering.classList.remove('animate__fadeOutUp');
      entering.classList.remove('animate__fadeOutDown');
    }
  }

  previous() {
    this.steps.forEach(step => step.value = _.clamp(step.value - 1, 0, 5));

    const step = this.steps[0].value;
    const entering = this.$el[0]
      .querySelector(`.animate__animated:nth-child(${step})`);
    const leaving = this.$el[0]
      .querySelector(`.animate__animated:nth-child(${step + 1})`);

    if (leaving) {
      leaving.classList.add('animate__fadeOutDown');
      leaving.classList.remove('animate__fadeOutUp');
      leaving.classList.remove('animate__fadeInUp');
      leaving.classList.remove('animate__fadeInDown');
    }

    if (entering) {
      entering.classList.add('animate__fadeInDown');
      entering.classList.remove('animate__fadeInUp');
      entering.classList.remove('animate__fadeOutUp');
      entering.classList.remove('animate__fadeOutDown');
    }
  }

  clickStep($el) {
    const $content = this.$el.find("> div");
    const contentHeight = $content[0].getBoundingClientRect().height;
    const stepHeight = (
      this.$el[0].getBoundingClientRect().height - contentHeight
    ) / 5;
    const scrollTop =
      this.$el[0].getBoundingClientRect().top + window.scrollY +
      ($el.data('step') - 1) * stepHeight + 1/5 * stepHeight;
    $("html, body").stop().animate({scrollTop}, 400, 'linear');
  }
}